import styled, { createGlobalStyle } from 'styled-components';
// import { Layout } from "~styles/layout";

export const HomeGlobalStyle = createGlobalStyle`
  background: #fff;
`;

export const Root = styled.div`
  width: 100%;
  padding-top: 56px;
`;

export const HomeLayout = styled.div`
  width: 1136px;
  margin: 0 auto;
  text-align: center;

  ${({ theme }) => theme.media.with('mobile', 'tablet')} {
    width: 100%;
  }
`;

export const BodyWrapper = styled.div`
  display: flex;
  gap: 0 30px;
  padding-top: 80px;

  ${({ theme }) => theme.media.with('mobile', 'tablet')} {
    display: block;
    gap: 0;
    padding-top: 0;
  }
`;

export const SideBannerWrapper = styled.div`
  ${({ theme }) => theme.media.with('mobile', 'tablet')} {
    overflow: hidden;
    margin: 60px 0 50px 0;
    padding: 0 16px;
  }

  ${({ theme }) => theme.media.tablet} {
    padding: 0 32px;
  }
`;

export const RecentCommentWrapper = styled.div`
  margin: 80px 0 95px;

  ${({ theme }) => theme.media.with('mobile', 'tablet')} {
    margin: 0 0 60px;
  }

  ${({ theme }) => theme.media.mobile} {
    padding: 0 16px;
  }

  ${({ theme }) => theme.media.tablet} {
    padding: 0 32px;
  }
`;
